// src/pages/Meijimura/CouponReward.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import '../../styles/CouponReward.css';

// ★ 閉じる（×）を押した時の遷移先。実際のルーティングに合わせて変更してください
const CLOSE_PATH = '/thanks';

// バンティング（三角旗）の座標・色データ
// x, y は viewBox="0 0 400 100" 上の吊り紐に沿った位置（つり下げ点）
const BUNTING_FLAGS = [
  { x: 32.8, y: 24.8, color: '#9fd8ea' },
  { x: 74.6, y: 41.1, color: '#f7d774' },
  { x: 116.4, y: 52.7, color: '#f3b08c' },
  { x: 158.2, y: 59.7, color: '#9fd8ea' },
  { x: 200, y: 62, color: '#f7d774' },
  { x: 241.8, y: 59.7, color: '#f3b08c' },
  { x: 283.6, y: 52.7, color: '#9fd8ea' },
  { x: 325.4, y: 41.1, color: '#f7d774' },
  { x: 367.2, y: 24.8, color: '#f3b08c' },
];

const FLAG_HALF_WIDTH = 13;
const FLAG_HEIGHT = 32;

export default function CouponReward() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClose = () => {
    navigate(CLOSE_PATH);
  };

  return (
    <div className="coupon-reward">
      <button
        type="button"
        className="coupon-reward__close"
        onClick={handleClose}
        aria-label={t('couponReward.close', '閉じる')}
      >
        ×
      </button>

      <div className="coupon-reward__inner">
        <div className="coupon-reward__bunting" aria-hidden="true">
          <svg
            viewBox="0 0 400 100"
            className="coupon-reward__bunting-svg"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10,14 Q200,110 390,14"
              fill="none"
              stroke="#4a4a4a"
              strokeWidth="2"
            />
            {BUNTING_FLAGS.map((flag, i) => (
              <polygon
                key={i}
                points={`${flag.x - FLAG_HALF_WIDTH},${flag.y} ${
                  flag.x + FLAG_HALF_WIDTH
                },${flag.y} ${flag.x},${flag.y + FLAG_HEIGHT}`}
                fill={flag.color}
              />
            ))}
          </svg>
        </div>

        <p className="coupon-reward__thanks">
          {t('couponReward.thanks', 'アンケート回答ありがとうございます！')}
        </p>

        <h1 className="coupon-reward__title">
          <span className="coupon-reward__bracket" aria-hidden="true">
            ＼
          </span>
          <span className="coupon-reward__highlight">
            {t('couponReward.subtitle', '明治村の売店で使える')}
          </span>
          <span className="coupon-reward__bracket" aria-hidden="true">
            ／
          </span>
        </h1>

        <div className="coupon-reward__ticket">
          <img
            src="/images/coupon.svg"
            alt=""
            className="coupon-reward__ticket-img"
          />
        </div>

        <p className="coupon-reward__note">
          {t(
            'couponReward.note',
            '※1回のお会計につき、1,000円以上ご利用の場合に限り、1回'
          )}
        </p>

        <div className="coupon-reward__shops">
          {t(
            'couponReward.shops',
            '【対象店舗】ミュージアムショップ・SL東京駅売店'
          )}
        </div>

        <div className="coupon-reward__description">
          <p>
            {t(
              'couponReward.instructions',
              'こちらの画面をスクリーンショットし会計時にスタッフへご提示ください。'
            )}
          </p>
          <p>
            {t(
              'couponReward.conditionPrefix',
              '1回のお会計が1,000円以上の場合に限り、'
            )}
            <span className="coupon-reward__highlight coupon-reward__highlight--inline">
              {t('couponReward.discount', '200円OFFとさせていただきます。')}
            </span>
          </p>
        </div>

        <p className="coupon-reward__footnote">
          {t('couponReward.validity', '※当日利用のみとなります。')}
        </p>
      </div>
    </div>
  );
}